import { render, staticRenderFns } from "./channel-data.vue?vue&type=template&id=fe272ad2&scoped=true&"
import script from "./channel-data.vue?vue&type=script&lang=js&"
export * from "./channel-data.vue?vue&type=script&lang=js&"
import style0 from "./channel-data.vue?vue&type=style&index=0&id=fe272ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe272ad2",
  null
  
)

export default component.exports